import React, { FC, useCallback, useContext, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Feature, MeteringModule, Permissions } from 'src/api/api.generated'
import { hicContext } from 'src/app/hooks/context/context'
import { useGrant } from './grant-hooks'

// type IfGrantedModuleProps = {
//   modules: MeteringModule[]
//   features?: Feature[]
//   permissions?: Permissions[]
// }

// type IfGrantedPermissionProps = {
//   permissions: Permissions[]
//   modules?: MeteringModule[]
//   features?: Feature[]
// }

// type IfGrantedFeatureProps = {
//   features: Feature[]
//   modules?: MeteringModule[]
//   permissions?: Permissions[]
// }

export type IfGrantedProps = {
  features?: Feature[]
  modules?: MeteringModule[]
  permissions?: Permissions[]
}

export type NoGrantProps = {
  noGrantContents?: React.ReactElement
  noGrantRoute?: string
  /***
   * Contenuto alternativo visibile quando non si possiede la licenza per uno specifico modulo.
   */
  noModuleLicenseContents?: React.ReactElement
}

// export type IfGrantedProps = (IfGrantedModuleProps & NoGrantProps) | (IfGrantedPermissionProps & NoGrantProps) | (IfGrantedFeatureProps & NoGrantProps)

/**
 * Wrapped contents are visible if authorization required has satisfied.
 * You can protect the contents combine different authorization levels (module, feature, permission)
 * @param props
 * @returns
 */
export const IfGranted: FC<IfGrantedProps & NoGrantProps> = (props) => {
  const { context } = useContext(hicContext)
  const { children, noGrantContents, noGrantRoute, noModuleLicenseContents } = props
  const navigate = useNavigate()
  const { isGranted } = useGrant()

  const isGrantedCheck = useMemo(() => {
    return isGranted({ modules: props.modules, features: props.features, permissions: props.permissions })
  }, [props, context.loading])

  const isModuleLicencedCheck = useCallback(() => {
    if (!context.loading && props.modules) {
      return props.modules.some((x) => context?.permissions?.modules?.includes(x))
    }
    return false
  }, [props, context.loading])

  useEffect(() => {
    if (noGrantRoute) {
      isGrantedCheck ? undefined : navigate(noGrantRoute)
    }
  }, [noGrantRoute, isGrantedCheck])

  if (context.loading) {
    return <>Please wait...</>
  } else {
    if (isGrantedCheck) {
      return <>{children}</>
    } else {
      if (!isModuleLicencedCheck() && noModuleLicenseContents) return noModuleLicenseContents
      else if (noGrantContents) return noGrantContents
    }
  }
  return <></>
}
